module.exports = __webpack_public_path__ + "media/a2.1ad56346.wav";